module.exports = __webpack_public_path__ + "img/compact.b1d51197.png";